import React from 'react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  Plus, ChevronDown, ImageIcon, Link as LinkIcon, FileText,
  StickyNote, HelpCircle,
} from 'lucide-react';

/**
 * "Add Evidence" dropdown that appears against every unresolved
 * ASSESSED_INPUT outcome. Splits into the five workflows the assessor asked
 * for so they never leave the review screen.
 */
export const AddEvidenceMenu = ({ outcomeId, onPickPhoto, onOpenQuickAdd }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button
        type="button"
        data-testid={`add-evidence-${outcomeId}`}
        className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded border border-slate-700 hover:border-emerald-500 hover:text-emerald-300 text-slate-300 focus:outline-none focus-visible:ring-1 focus-visible:ring-emerald-400"
      >
        <Plus className="w-3 h-3" />
        Evidence
        <ChevronDown className="w-3 h-3 opacity-60" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent
      align="end"
      className="bg-slate-900 border-slate-800 text-slate-100 min-w-[220px]"
    >
      <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-slate-500">
        Add evidence to outcome
      </DropdownMenuLabel>
      <DropdownMenuSeparator className="bg-slate-800" />
      <DropdownMenuItem
        onSelect={() => onPickPhoto?.()}
        data-testid={`add-menu-photo-${outcomeId}`}
        className="cursor-pointer focus:bg-slate-800 focus:text-emerald-300"
      >
        <ImageIcon className="w-3.5 h-3.5 mr-2 text-emerald-400" />
        Add Photo
        <span className="ml-auto text-[10px] text-slate-500">from project</span>
      </DropdownMenuItem>
      <DropdownMenuItem
        onSelect={() => onOpenQuickAdd?.('research')}
        data-testid={`add-menu-research-${outcomeId}`}
        className="cursor-pointer focus:bg-slate-800 focus:text-emerald-300"
      >
        <LinkIcon className="w-3.5 h-3.5 mr-2 text-emerald-400" />
        Add Research
        <span className="ml-auto text-[10px] text-slate-500">URL / PDF</span>
      </DropdownMenuItem>
      <DropdownMenuItem
        onSelect={() => onOpenQuickAdd?.('technical_doc')}
        data-testid={`add-menu-tech-${outcomeId}`}
        className="cursor-pointer focus:bg-slate-800 focus:text-emerald-300"
      >
        <FileText className="w-3.5 h-3.5 mr-2 text-emerald-400" />
        Add Technical Document
      </DropdownMenuItem>
      <DropdownMenuItem
        onSelect={() => onOpenQuickAdd?.('site_note')}
        data-testid={`add-menu-note-${outcomeId}`}
        className="cursor-pointer focus:bg-slate-800 focus:text-emerald-300"
      >
        <StickyNote className="w-3.5 h-3.5 mr-2 text-emerald-400" />
        Add Site Note
      </DropdownMenuItem>
      <DropdownMenuSeparator className="bg-slate-800" />
      <DropdownMenuItem
        onSelect={() => onOpenQuickAdd?.('assumption')}
        data-testid={`add-menu-assumption-${outcomeId}`}
        className="cursor-pointer focus:bg-slate-800 focus:text-cyan-300"
      >
        <HelpCircle className="w-3.5 h-3.5 mr-2 text-cyan-400" />
        Record Assumption
        <span className="ml-auto text-[10px] text-slate-500">defended default</span>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
